var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect, useContext } from 'react';
import { SharingInput, SharingInputWrapper, SharingWrapper, SharingButton, SharingDialog, SharingErrorBanner, SharingCheckboxLabel, } from './components';
import { Backdrop, createBasicColorSet, IconCheck, } from '@spotify-internal/encore-web';
import { isArabicMarket } from '../../utils/helpers';
import DirectionContext from '../../configuration/context/direction';
import MarketContext from '../../configuration/context/market';
const Sharing = ({ legalAgreementText, legalAgreementError, ctaCopyText, ctaShareText, shareLink, shareTitle, shareText, ctaBackgroundColor, successText, containerBackgroundColor, containerAriaLabel, id, }) => {
    const [isCopied, setIsCopied] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [isChecked, setChecked] = useState(false);
    const [buttonText, setButtonText] = useState(ctaCopyText);
    const handleCheckboxClick = () => setChecked(!isChecked);
    const market = useContext(MarketContext);
    const direction = useContext(DirectionContext);
    useEffect(() => {
        if (navigator.share && ctaShareText) {
            setButtonText(ctaShareText);
        }
    }, [ctaShareText]);
    const dialogBody = () => {
        return (React.createElement("div", { role: "alert", "aria-labelledby": "successTextDialog" },
            React.createElement(IconCheck, { iconSize: 64 }),
            React.createElement("p", { id: "successTextDialog" }, successText)));
    };
    const copyToClipboardFallback = () => {
        const successful = document.execCommand(shareLink);
        if (successful) {
            setIsCopied(true);
            setIsErrorVisible(false);
        }
    };
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!isChecked)
            setIsErrorVisible(true);
        else {
            if (navigator.share) {
                const shareData = {
                    title: shareTitle,
                    text: shareText,
                    url: shareLink,
                };
                try {
                    yield navigator.share(shareData).then(() => setIsErrorVisible(false));
                }
                catch (_a) {
                    console.log('navigator.share failed');
                }
            }
            else {
                if (!navigator.clipboard)
                    copyToClipboardFallback();
                else {
                    try {
                        yield navigator.clipboard.writeText(shareLink).then(() => {
                            setIsCopied(true);
                            setIsErrorVisible(false);
                            setTimeout(() => setIsCopied(false), 8000);
                        });
                    }
                    catch (_b) {
                        console.log('navigator.clipboard failed');
                    }
                }
            }
        }
    });
    return (React.createElement(SharingWrapper, null,
        isCopied && (React.createElement(Backdrop, { center: true },
            React.createElement(SharingDialog, { body: dialogBody() }))),
        React.createElement(SharingInputWrapper, { "aria-label": containerAriaLabel, "aria-disabled": !isChecked, "aria-live": "polite" },
            React.createElement(SharingInput, { tabIndex: isChecked ? 0 : -1, containerBackgroundColor: containerBackgroundColor, "aria-hidden": !isChecked }, shareLink)),
        legalAgreementText && (React.createElement(React.Fragment, null,
            React.createElement(SharingCheckboxLabel, { htmlFor: "agree-tc" },
                React.createElement("input", { type: "checkbox", id: "agree-tc", onClick: handleCheckboxClick, required: true }),
                legalAgreementText),
            isErrorVisible && !isChecked && (React.createElement(SharingErrorBanner, { colorSet: "negative" }, legalAgreementError)))),
        React.createElement(SharingButton, { id: id, type: "button", UNSAFE_colorSet: createBasicColorSet(ctaBackgroundColor || '#000'), copySuccess: isCopied, children: buttonText, onClick: handleClick, buttonLegacy: isArabicMarket(market, direction) ? false : true })));
};
export default Sharing;
//# sourceMappingURL=sharing.js.map